export default __webpack_public_path__ + "static/media/Schwein-mit-Kleeblatt.62d88ad3.png";